module["exports"] = ["gmail.com", "seznam.cz", "centrum.cz", "volny.cz", "atlas.cz"];